import React, { FC } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/typography.module.scss'
import text from 'styles/utility/text.module.scss'
import HTMLReactParser from 'html-react-parser'
import { returnCodeToBr } from 'lib/helper'

type Props = {
  align?: 'center' | 'left' | 'right'
  caution: string
  size?: 'small' | 'medium' | 'large'
}

const CautionHeadline: FC<Props> = (props) => {
  const { align = 'center', caution, size = 'medium' } = props
  return (
    <h2
      className={classNames({
        [styles.headline_caution]: size === 'medium',
        [styles.headline_caution_small]: size === 'small',
        [styles.headline_caution_large]: size === 'large',
        [text.align_left]: align === 'left',
        [text.align_center]: align === 'center',
        [text.align_right]: align === 'right',
      })}
      data-cy={'caution-headline'}
    >
      {HTMLReactParser(returnCodeToBr(caution))}
    </h2>
  )
}

export default CautionHeadline
